import React from 'react'

import DatePicker from 'react-toolbox/lib/date_picker/DatePicker';
import TimePicker from 'react-toolbox/lib/time_picker/TimePicker';

import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import Button from 'react-toolbox/lib/button/Button';
import IconButton from 'react-toolbox/lib/button/IconButton';

// REDUX IMPORTS
import './DateSelector.css'

let to;
let from;
let stations;
let online;
let group;
let alias;

export const DateSelector = props => {

    to = props.to;
    from = props.from;
    stations = props.stations;
    online = props.online;
    group = props.group;
    alias = props.alias;

    const handleChange = (item, value) => {
        if(item === 'online')
            value = value.target.checked;
        else if(item === 'group')
            value = value.target.value;
        props.handleChange(item, value);
    };

    return (
        <div className='datePickerContainer'>
            <h3 className="formHeader"><b>Data Explorer</b></h3>
            <div className='row datePickerSelector'>
                <div className='col-sm-10 col-xs-12'>
                    <div className='row'>
                        <div className='col-sm-2 hidden-xs'>
                            <IconButton className='centeredButton' icon='date_range' accent/>
                        </div>
                        <div className='col-sm-5 col-xs-6'>
                            <div className="inputForm">
                                <DatePicker label={'From'}
                                            onChange={handleChange.bind(this, 'from')}
                                            value={from}
                                />
                            </div>
                        </div>
                        <div className='col-sm-5 col-xs-6'>
                            <div className="inputForm">
                                {!online && <DatePicker label={'To'}
                                            onChange={handleChange.bind(this, 'to')}
                                            value={to}
                                />}
                            </div>
                        </div>
                        Live Mode
                        <Switch
                            checked={online}
                            onChange={handleChange.bind(this, 'online')}
                            value="checkedA"
                        />
                        <FormControl>
                            <InputLabel htmlFor="age-simple">Group by</InputLabel>
                            <Select
                                value={group}
                                onChange={handleChange.bind(this, 'group')}
                            >
                                <MenuItem value={1}>10 Min</MenuItem>
                                <MenuItem value={3}>30 Min</MenuItem>
                                <MenuItem value={6}>1 Hour</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    {/*<div className='row'>*/}
                        {/*<div className='col-sm-2 hidden-xs'>*/}
                            {/*<IconButton className='centeredButton' icon='access_time' accent/>*/}
                        {/*</div>*/}
                        {/*<div className='col-sm-5 col-xs-6'>*/}
                            {/*<div className="inputForm">*/}
                                {/*<TimePicker label={'From'}*/}
                                            {/*onChange={handleChange.bind(this, 'from')}*/}
                                            {/*value={from}*/}
                                {/*/>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className='col-sm-5 col-xs-6'>*/}
                            {/*<div className="inputForm">*/}
                                {/*<TimePicker label={'To'}*/}
                                            {/*onChange={handleChange.bind(this, 'to')}*/}
                                            {/*value={to}*/}
                                {/*/>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                </div>
                <div className='col-sm-2 hidden-xs datePickerSubmit'>
                    <Button onClick={() => props.handleSubmit(from, to, stations, alias)} label='Submit' primary
                            raised/>
                </div>
            </div>
            <div className='row center'>
                <div className='col-xs-1  visible-xs'>
                    <Button onClick={() => props.handleSubmit(from, to, stations, alias)} label='Submit' primary
                            raised/>
                </div>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/DashBoard/ManageStations/StationCharts/DateSelector/DateSelector.js